import { AddressType } from '@steelbuy/ts-shared';
import { useGetAddress } from './getAddress';
import { FilterComparator, SortDirection } from '../../utils/types';

export const useGetWarehouseAddress = () =>
    useGetAddress({
        limit: 100,
        offset: 0,
        filter: [
            {
                property: 'addressType',
                comparator: FilterComparator.EQUAL,
                value: AddressType.WAREHOUSE,
            },
        ],
        sort: [
            {
                property: 'primary',
                direction: SortDirection.DESCENDING,
            },
            {
                property: 'postalCode',
                direction: SortDirection.ASCENDING,
            },
        ],
    });
